import{j as t}from"./chunk-GEPA7FLG.js";t();var s=e=>{if(e===void 0||e.length===0)return!1;let n=e.split("-");return!(n.length!==2||n[0].length<=1||n[1].length!==6)};export{s as a};
//# sourceMappingURL=chunk-BGR4W7GF.js.map
